"use client";
import React from "react";
import Footer from "../components/Footer";
import PlainText from "../components/common/PlainText";

const CookiePolicy: React.FC = () => {

    const sections = [
        {
            id: 1,
            title: "Introduction",
            content: [
                'EPAYR PAYMENT SOLUTIONS LIMITED (or “we”) respects and cares about Your privacy. This Policy describes the procedures and practices regarding our use of cookies on the website www.epayr.finance. We are using cookies to improve the website’s functionality and provide safer user experience.',
                '“You” in this Policy refers to a visitor/user of our website.',
                'Please be informed that we Policy may be updated.'
            ],
        },
        {
            id: 2,
            title: "What are ?",
            titleHighlight: "cookies",
            content: [
                "Most websites need to collect certain basic information about their users to work properly. Therefore, websites rely on cookies – small text files, that are stored on Your device for browsing (computer, mobile device or tablet). They contain basic information about Your internet use and Your browser sends these cookies back to our website every time You revisit it, so it can recognize Your computer or mobile device. Cookies used by our website cannot harm Your device and we don't ever store Your sensitive data in cookies.",
            ],
        },
        {
            id: 3,
            title: "How we ",
            titleHighlight: "use cookies?",
            titleReverse: true,
            content: [
                'Cookies serve many functions but in general we process cookies on our website for the following purposes:<ul style="list-style: decimal"><li>To remember Your login state so You don’t have to login as You navigate through our website and Your dashboard;</li><li>To remember the parts of site visited by the user to provide engaging content for the site visitors and further disclose issues that are topical for the users;</li><li>To collect information about computers and web browsers used to access our website (this information helps us monitor for and detect potentially harmful or illegal use of our services);</li><li>To provide the smooth browsing experience for visitors by verifying and ensuring compatibility of the site with the device and browser version;</li><li>To maintain the statistics on how often users visit certain parts of the site, the data is implemented by developers of the site to tailor its usability and enhance the performance.</li></ul>'
            ],
        },
        {
            id: 4,
            title: "What types of ",
            titleHighlight: "cookies do we use?",
            content: [
                '<ul style="list-style: decimal"><li>Essential cookies. These are essential to enable You to navigate around our website and use its features in full. Without these we would be incapable to enable the use of our website’s features. We also rely on the essential cookies to ensure the highest standards of data security on our pages and to comply with industry security standards;</li><li>Performance cookies. We rely on performance (or analytics) cookies to help us understand how You arrived at our website, the way and how long You use it and ways we can improve Your user experience. These cookies are anonymous and do not process any personal data. Some of the performance cookies we use are issued as part of services provided by selected third parties;</li><li>Functionality cookies. These cookies allow us to remember choices You make on our website and to provide You enhanced and more personal features;</li><li>Targeting cookies. Our website does not use targeting cookies to deliver targeted advertising to You.</li></ul>'
            ],
        },
        {
            id: 5,
            title: "How to limit the use of cookies?",
            titleHighlight: "the use of cookies?",
            titleReverse: true,
            content: [
                "You can limit the use of cookies at any time by changing Your browser settings and deleting the cookies stored. If You don’t want cookies to be used on Your devices, simply change the security settings of Your browser. Security settings may differ in browsers and have to changes in each of them. By not to accepting the cookies, your ability to use of our website’s features may be affected and some of them may not operate as intended.",
            ],
        },
        {
            id: 6,
            title: "Contact us",
            titleHighlight: "us",
            content: [
                "In case You have any questions or comments regarding our Cookie Policy, please contact us at <a href='mailto:info@epayr.finance'>info@epayr.finance</a>",
            ],
        }
    ];

  return (
        <main>
        <PlainText
      title="Cookie Policy"
      titleHighlight=""
      sections={sections}
    //   sectionSpacing = {{md: "60px", xs: "50px"}}
      sectionContentSx={{
        color: "gray.400",
        lineHeight: "150% !important",
      }}
    />
        <Footer 
              buttonText="" 
              buttonLink=""
              ctaText={{
                prefix: '',
                highlight1: '',
                middle: '',
                highlight2: '',
                suffix: ''
              }}
            />
        </main>
  );
};

export default CookiePolicy;
